/**
 * summernote-resize-three-quarter.js
 *
 * Registers a custom "75%" image resize button for Summernote.
 *
 * Usage:
 *   import { registerResizeThreeQuarter } from './summernote-resize-three-quarter';
 *   registerResizeThreeQuarter(); // call before Vue.use(VueSummernote)
 *
 * The button resizes the selected image to 75% width and triggers
 * the input event to update the Vue v-model.
 */

export function registerResizeThreeQuarter() {
  $.extend($.summernote.plugins, {
    'resizeThreeQuarter': function (context) {
      const ui = $.summernote.ui;

      context.memo('button.resizeThreeQuarter', function () {
        return ui.button({
          contents: '75%',
          tooltip: 'Resize three quarter',
          click: function () {
            const $img = $(context.invoke('editor.restoreTarget'));
            if ($img && $img.length) {
              $img.css({ width: '75%' });
              $(context.layoutInfo.editable).trigger('input');
            }
          }
        }).render();
      });
    }
  });
}
